import { Link } from 'react-router-dom';
import { featuredGames } from '@/mocks/home';

export default function HotGames() {
  return (
    <section className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热门游戏推荐</h2>
            <p className="text-foreground-600 text-sm">千万玩家正在畅玩的精品游戏</p>
          </div>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {featuredGames.map((game) => (
            <div
              key={game.id}
              className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={game.image}
                  alt={game.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2.5 left-2.5">
                  <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    game.label === '热门'
                      ? 'bg-primary-500 text-background-50'
                      : game.label === '推荐'
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-secondary-500 text-background-50'
                  }`}>
                    {game.label}
                  </span>
                </div>
                <div className="absolute top-2.5 right-2.5 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm rounded-full px-2 py-0.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-foreground-800 text-xs font-medium">{game.rating}</span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-1.5">
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm">{game.name}</h3>
                  <span className="text-foreground-500 text-xs bg-secondary-100 px-2 py-0.5 rounded-md">{game.category}</span>
                </div>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2 mb-3">{game.description}</p>
                <div className="flex items-center text-foreground-500 text-xs">
                  <i className="ri-user-line mr-1"></i>
                  <span>{(game.players / 10000).toFixed(1)}万人在玩</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}